import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Draggable from "react-draggable";

const NativePopup = ({
  children,
  className = "",
  style,
  isDraggable = true,
  isResizable = true,
  hideTrigger = false,
  initialized,
  showing,
  shown,
  hiding,
  hidden,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const hostRef = useRef(null);
  const backdropRef = useRef(null);
  const apiRef = useRef(null);

  if (!apiRef.current) {
    apiRef.current = {
      hostElement: null,
      _bkDrop: null,
      show() {
        showing?.(apiRef.current);
        setIsOpen(true);
        requestAnimationFrame(() => {
          setIsVisible(true);
          shown?.(apiRef.current);
        });
      },
      hide() {
        hiding?.(apiRef.current);
        setIsVisible(false);
        setTimeout(() => {
          setIsOpen(false);
          hidden?.(apiRef.current);
        }, 180);
      },
    };
  }

  useEffect(() => {
    initialized?.(apiRef.current);
  }, []);

  useEffect(() => {
    apiRef.current.hostElement = hostRef.current;
    apiRef.current._bkDrop = backdropRef.current;
  }, [isOpen]);

  const popup = (
    <div
      ref={backdropRef}
      className={`maxis-popup-backdrop${isOpen ? " is-open" : ""}`}
      aria-hidden={!isOpen}
      style={{ display: isOpen ? "flex" : "none" }}
      onMouseDown={(event) => {
        if (hideTrigger && event.target === event.currentTarget) {
          apiRef.current.hide();
        }
      }}
    >
      {/* cancel: 헤더(드래그 핸들) 안의 조작 요소는 드래그를 시작하지 않는다.
          없으면 터치(모바일 · DevTools device emulation)에서 닫기(x) 버튼을 눌렀을 때
          react-draggable 이 touchstart 를 preventDefault 해 click 이 발생하지 않는다. */}
      <Draggable
        disabled={!isDraggable}
        handle=".modal-header"
        cancel="button, input, select, textarea, a"
      >
        <div
          ref={hostRef}
          className={`maxis-popup custom-animation ${isVisible ? "custom-animation-visible" : ""} ${className || ""}`}
          style={{
            ...style,
            resize: isResizable ? "both" : "none",
          }}
          tabIndex={-1}
          onKeyDown={(event) => {
            if (event.key === "Escape") event.preventDefault();
          }}
        >
          {children}
        </div>
      </Draggable>
    </div>
  );

  // #popup-root keeps React's portal children in a container it fully owns. Portalling
  // into <body> put them next to nodes React knows nothing about (grid context menu,
  // extensions, translate wrappers), and a sibling appearing or vanishing there is one
  // way to reach "removeChild: the node to be removed is not a child of this node".
  // Falls back to <body> so an older index.html still renders.
  return createPortal(popup, document.getElementById("popup-root") || document.body);
};

export default NativePopup;
